import React, { useContext } from 'react'
import PropTypes from 'prop-types'

import GlobalContext from 'agency/digital_renderer/utils/context'
import deviceStyle from 'agency/digital_renderer/utils/deviceStyle'

import AnimationWrapper from 'agency/digital_renderer/themes/RealhubDynamic/ui/AnimationWrapper'
import ElementContainer from '../../ElementContainer'

const findContainer = items => items.find(item => item.item_type === 'container')

const filterDocuments = (documents, filters) => {
  const { limit, offset } = filters || {}

  const filterOffset = offset && offset !== 0 ? offset : 0
  const filterLimit = limit ? limit + filterOffset : null

  const limited = filterLimit ? documents.slice(filterOffset, filterLimit) : documents.slice(filterOffset)

  return limited
}

const renderDocuments = (documents, documentContainer) => documents.map(document => (
  <div key={document.id} style={deviceStyle(documentContainer)}>
    <ElementContainer
      forwardContextToItems={document}
      section={documentContainer}
      renderNested
      render={({ itemComponents }) => itemComponents.map(component => component)}
    />
  </div>
))

const CampaignDocuments = (props) => {
  const { items, options } = props

  const { limit, offset } = options || {}

  const documentContainer = findContainer(items) || {}
  const style = deviceStyle(props)

  const defaultContext = useContext(GlobalContext)
  const { campaignDocuments } = defaultContext

  const filteredDocuments = filterDocuments(campaignDocuments, {
    limit,
    offset,
  })

  return (
    <AnimationWrapper options={options}>
      <div style={style}>
        {renderDocuments(filteredDocuments, documentContainer)}
      </div>
    </AnimationWrapper>
  )
}

CampaignDocuments.propTypes = {
  items: PropTypes.array.isRequired,
  options: PropTypes.object.isRequired,
}

export default CampaignDocuments
